import StoryArrowIcon from '@/assets/story-arrow.svg?react'
import { motion, useReducedMotion, type Variants } from 'motion/react'
import type { MouseEventHandler } from 'react'
import styles from './StoryFeedList.module.css'

export interface StoryFeedScrollButtonProps {
	direction: 'backward' | 'forward'
	onClick: MouseEventHandler<HTMLButtonElement>
}

const STORY_FEED_SCROLL_BUTTON_DELAY_SECONDS = 0.3
const STORY_FEED_SCROLL_BUTTON_VARIANTS: Variants = {
	hidden: {
		opacity: 0,
	},
	visible: {
		opacity: 1,
		transition: {
			delay: STORY_FEED_SCROLL_BUTTON_DELAY_SECONDS,
			duration: 0.2,
			ease: 'easeOut',
		},
	},
}

export default function StoryFeedScrollButton({ direction, onClick }: StoryFeedScrollButtonProps) {
	const prefersReducedMotion = useReducedMotion()
	const isForward = direction === 'forward'

	return (
		<motion.button
			type="button"
			className={`${styles.scrollButton} ${isForward ? styles.scrollForward : styles.scrollBackward}`}
			variants={STORY_FEED_SCROLL_BUTTON_VARIANTS}
			initial={prefersReducedMotion ? false : 'hidden'}
			animate="visible"
			onClick={onClick}
			aria-label={isForward ? '查看后一组日记' : '查看前一组日记'}
		>
			<StoryArrowIcon className={isForward ? styles.arrowForward : undefined} aria-hidden="true" />
		</motion.button>
	)
}
